export default "__VITE_ASSET__GDbBnZua__"